import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface ProgressPlanIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function ProgressPlanIcon({
  color = RoutalPalette.secondary20,
  style = {},
  ...props
}: ProgressPlanIconProps) {
  const fillColor = style.color || color;
  return (
    <SvgIcon {...props} viewBox="0 0 12 12" style={{ height: `14px`, width: `14px`, ...style }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path
          d="M0.528931 8.6832L1.57747 6.79045L3.47023 7.83899"
          stroke={fillColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.57745 6.97992C2.03206 9.24015 4.0286 10.9424 6.42273 10.9424C9.15234 10.9424 11.3651 8.72965 11.3651 6.00004C11.3651 5.67036 11.3329 5.34823 11.2713 5.03662"
          stroke={fillColor}
          strokeLinecap="round"
        />
        <path
          d="M1.69324 4.56039C2.30953 2.53291 4.19383 1.05747 6.42274 1.05747C8.07495 1.05747 9.53781 1.86819 10.4352 3.11351"
          stroke={fillColor}
          strokeLinecap="round"
          strokeDasharray="2 2"
        />
      </svg>
    </SvgIcon>
  );
}
